import Button from './controls/button';
import Checkbox from './controls/checkbox';
import { Date, DateTime, Time } from './controls/date';
import Option from './controls/option';
import OptionGroup from './controls/optionGroup';
import Plaintext from './controls/plaintext';
import Radio from './controls/radio';
import RadioGroup from './controls/radioGroup';
import Select from './controls/select';
import Text from './controls/text';
import TextArea from './controls/textArea';
import TextEmail from './controls/textEmail';
import TextNumberInteger from './controls/textNumberInteger';
import TextNumberFloat from './controls/textNumberFloat';
import TextPassword from './controls/textPassword';
import TextPhone from './controls/textPhone';
import TextThrottled from './controls/textThrottled';

const Inputs = {
  Button,
  Checkbox,
  Date,
  DateTime,
  Time,
  Option,
  OptionGroup,
  Plaintext,
  Radio,
  RadioGroup,
  Select,
  Text,
  TextArea,
  Email: TextEmail,
  Integer: TextNumberInteger,
  Float: TextNumberFloat,
  Password: TextPassword,
  Phone: TextPhone,
  Throttled: TextThrottled,
};

Inputs.Option.Group = OptionGroup;
Inputs.Radio.Group = RadioGroup;
Inputs.Text.Email = TextEmail;
Inputs.Text.Integer = TextNumberInteger;
Inputs.Text.Float = TextNumberFloat;
Inputs.Text.Password = TextPassword;
Inputs.Text.Phone = TextPhone;
Inputs.Text.Throttled = TextThrottled;
Inputs.Select.Option = Option;
Inputs.Select.Option.Group = OptionGroup;

export default Inputs;